'use strict';

import Highcharts from "highcharts/highstock.src";
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("highchartDraggablePoints", function () {
  return {
    getSelectionModes: function getSelectionModes() {
      return [{
        id: "POINT",
        label: "Point uniquement"
      }, {
        id: "NEXT",
        label: "Point et suivants"
      }, {
        id: "PREVIOUS",
        label: "Point et précédents"
      }, {
        id: "STEP",
        label: "Points du palier"
      }, {
        id: "ALL",
        label: "Tous les points"
      }];
    },
    getDragModes: function getDragModes() {
      return [{
        id: "POSITION",
        label: "Positionner"
      }, {
        id: "TRANSLATION",
        label: "Translater"
      }];
    }
  };
});

/**
 * Home-made Highchart draggable points plugin.
 *
 * Greatly inspired from Draggable points plugin from Torstein Honsi (MIT License)
 */
(function (Highcharts) {
  var addEvent = Highcharts.addEvent,
    each = Highcharts.each,
    pick = Highcharts.pick;
  var selectionModes = ["POINT", "ALL", "STEP", "NEXT", "PREVIOUS"];
  var dragModes = ["POSITION", "TRANSLATION"];
  Highcharts.Chart.prototype.callbacks.push(function (chart) {
    var container = chart.container,
      options,
      dragOptions,
      dragged = false,
      originY,
      dragPoint,
      dragY,
      dragPlotY,
      selectionMode,
      dragMode;
    var getSelection = function getSelection(event, selectionMode) {
      var data = dragPoint.series.data;
      switch (selectionMode) {
        case "POINT":
          return [dragPoint];
        case "STEP":
          var index = dragPoint.index,
            originY = event.originY,
            min = index,
            max = index;
          if (index < data.length - 1) {
            for (var i = index + 1; i < data.length; i++) {
              if (data[i].y == originY) {
                max = i;
              } else {
                break;
              }
            }
          }
          if (index > 0) {
            for (var i = index - 1; i >= 0; i--) {
              if (data[i].y == originY) {
                min = i;
              } else {
                break;
              }
            }
          }
          return data.slice(min, max + 1);
        case "NEXT":
          return _.slice(data, dragPoint.index);
        case "PREVIOUS":
          return _.take(data, dragPoint.index + 1);
        case "ALL":
          return data;
      }
      return [dragPoint];
    };
    var computeNewPosition = function computeNewPosition(e) {
      var originalEvent = e.originalEvent || e,
        series = dragPoint.series,
        newX = dragPoint.x,
        newY;
      if (options.draggable) {
        var pageY = originalEvent.changedTouches ? originalEvent.changedTouches[0].pageY : e.pageY,
          deltaY = dragY - pageY,
          newPlotY = chart.plotHeight - dragPlotY + deltaY;
        newY = dragY === undefined ? dragPoint.y : dragPoint.series.yAxis.translate(newPlotY, true);
        if (dragOptions.dragStep) {
          newY = dragOptions.dragStep * parseInt(newY / dragOptions.dragStep);
        }
      } else {
        newY = dragPoint.y;
      }

      // verifie que l'on ne sorte pas des bornes imposées dans la config
      if (dragOptions.maxY !== undefined && newY > dragOptions.maxY) {
        newY = dragOptions.maxY;
      } else if (dragOptions.minY !== undefined && newY <= dragOptions.minY) {
        newY = dragOptions.minY;
      }
      return {
        x: newX,
        y: newY
      };
    };
    var applyPositionChange = function applyPositionChange(e, selectionMode, dragMode, doRedraw) {
      var newPosition = computeNewPosition(e),
        selection = getSelection(e, selectionMode);
      if (dragMode === "POSITION") {
        _.each(selection, function (point) {
          point.update({
            x: point.x,
            y: newPosition.y
          }, false);
        });
      } else {
        var offset = newPosition.y - dragPoint.y;
        _.each(selection, function (point) {
          point.update({
            x: point.x,
            y: point.y + offset
          }, doRedraw);
        });
      }
    };
    function mouseDown(e) {
      var hoverPoint = chart.hoverPoint,
        originalEvent = e.originalEvent || e;
      if (hoverPoint) {
        options = hoverPoint.series.options;
        dragOptions = options.dragOptions || {};
        originY = hoverPoint.y;
        selectionMode = dragOptions.selectionMode ? _.result(dragOptions, "selectionMode") : "POINT";
        dragMode = dragOptions.dragMode ? _.result(dragOptions, "dragMode") : "TRANSLATION";
        if (options.draggable) {
          dragPoint = hoverPoint;
          dragY = originalEvent.changedTouches ? originalEvent.changedTouches[0].pageY : e.pageY;
          dragPlotY = dragPoint.plotY + (chart.plotHeight - (dragPoint.yBottom || chart.plotHeight));
        }

        // Disable zooming when dragging
        if (dragPoint) {
          chart.mouseIsDown = false;
        }
      }
    }
    function mouseMove(e) {
      e.preventDefault();
      if (dragPoint) {
        var proceed = false,
          series = dragPoint.series,
          newPosition = computeNewPosition(e);
        dragged = true;

        // Fire the 'drag' event with a default action to move the point.
        dragPoint.firePointEvent('drag', {
          originY: originY,
          newY: newPosition.y
        }, function () {
          proceed = true;

          // Hide halo while dragging
          if (series.halo) {
            series.halo = series.halo.destroy();
          }
          if (chart.tooltip) {
            chart.tooltip.refresh(chart.tooltip.shared ? [dragPoint] : dragPoint);
          }
          applyPositionChange(e, selectionMode, dragMode, false);
          series.redraw();
        });

        // The default handler has not run because of prevented default
        if (!proceed) {
          drop();
        }
      }
    }
    function drop(e) {
      if (dragPoint && e && dragged) {
        var newPosition = computeNewPosition(e);
        dragPoint.firePointEvent('drop', {
          originY: originY,
          newY: newPosition.y
        });
        applyPositionChange(e, selectionMode, dragMode, true); // used to force yAxis to recompute min / max

        chart.redraw();
      }
      dragPoint = dragY = originY = undefined;
      dragged = false;
    }

    // Kill animation (why was this again?)
    chart.redraw();

    // Add'em
    addEvent(container, 'mousemove', mouseMove);
    addEvent(container, 'touchmove', mouseMove);
    addEvent(container, 'mousedown', mouseDown);
    addEvent(container, 'touchstart', mouseDown);
    addEvent(document, 'mouseup', drop);
    addEvent(document, 'touchend', drop);
    addEvent(container, 'mouseleave', drop);
  });

  /**
   * Extend the column chart tracker by visualizing the tracker object for small points
   */
  Highcharts.wrap(Highcharts.seriesTypes.column.prototype, 'drawTracker', function (proceed) {
    var series = this,
      options = series.options;
    proceed.apply(series);
    if (options.draggable) {
      each(series.points, function (point) {
        point.graphic.attr(point.shapeArgs.height < 3 ? {
          'stroke': 'black',
          'stroke-width': 2,
          'dashstyle': 'shortdot'
        } : {
          'stroke-width': series.options.borderWidth,
          'dashstyle': series.options.dashStyle || 'solid'
        });
      });
    }
  });
})(Highcharts);


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/serie-editor/highcharts.draggable-points.js
// module id = 2967
// module chunks = 13